import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const redirect = searchParams.get("redirect") || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.message || "Could not log in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center justify-center px-6 py-32">
      <form onSubmit={handleSubmit} className="w-full max-w-sm" data-testid="login-form">
        <p className="font-serif-lux italic font-light text-4xl mb-2">Welcome back.</p>
        <p className="text-xs font-light text-[#5C5C5C] mb-12">Log in to continue to your account.</p>

        <label className="block mb-8">
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#5C5C5C]">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="w-full bg-transparent border-b border-[#111111] py-3 mt-1 outline-none focus:border-[#C07C5F] transition-colors duration-500 font-light"
            placeholder="ava@studio.com"
          />
        </label>
        <label className="block mb-10">
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#5C5C5C]">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="w-full bg-transparent border-b border-[#111111] py-3 mt-1 outline-none focus:border-[#C07C5F] transition-colors duration-500 font-light"
            placeholder="••••••••"
          />
        </label>

        <button
          type="submit"
          disabled={submitting}
          data-testid="login-submit-btn"
          className="group w-full flex items-center justify-center gap-3 bg-[#111111] text-[#F9F8F6] rounded-full py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-[#C07C5F] transition-colors duration-500 disabled:opacity-50"
        >
          {submitting ? "Logging in…" : "Log In"}
          <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1.5" />
        </button>

        <p className="text-center text-xs font-light text-[#5C5C5C] mt-8">
          New here?{" "}
          <Link to={`/signup?redirect=${encodeURIComponent(redirect)}`} className="text-[#111111] hover:text-[#C07C5F] transition-colors duration-300">
            Create an account
          </Link>
        </p>
      </form>
    </section>
  );
};

export default Login;
